import { gql } from '@apollo/client';
import { useQuery } from '@apollo/client/react';
import { Structure } from '@lib/domain/stuctures';
import { PVTContext } from '@lib/context/pvt.context';
import { useContext } from 'react';

const STRUCTURE_SEARCH = gql`
  query StructureSearch($searchText: String!, $electionId: ID!) {
    gisStructureSearch(searchText: $searchText, electionId: $electionId) {
      code
      country
      province
      region
      constituency
      municipality
      ward
      votingdistrict
      type
      name
    }
  }
`;

interface StructureSearchReturns {
  loading: boolean;
  error?: any;
  structures?: Structure[];
}

interface StructureSearchQuery {
  gisStructureSearch: Structure[];
}

export default function useStrcutureSearch(
  searchText: string
): StructureSearchReturns {
  const { storedElectionId } = useContext(PVTContext);
  const { loading, error, data } = useQuery<StructureSearchQuery>(
    STRUCTURE_SEARCH,
    {
      variables: { searchText: searchText ?? '', electionId: storedElectionId },
      skip: !storedElectionId || searchText?.trim().length < 3,
    }
  );

  return { loading, error, structures: data?.gisStructureSearch };
}
